// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"70ca93f9","893":"01d1a26d"}[chunkId] + ".chunk.js";
};